"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _typeof2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _dataMarket = require("@/api/dataMarket/dataMarket");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import countTo from 'vue-count-to'
var _default = exports.default = {
  name: 'DataPresentation',
  // components: { countTo },
  data: function data() {
    return {
      startVal: 0,
      dataList: {
        'memberData': {
          'total': {
            'registeredCount': 0,
            'orderedCount': 0
          },
          'last': {
            'registeredCount': 0,
            'orderedCount': null
          },
          'month': {
            'registeredCount': 0,
            'orderedCount': null
          },
          'lastMonth': {
            'registeredCount': 0,
            'orderedCount': null
          },
          'today': {
            'registeredCount': 0,
            'orderedCount': null
          }
        },
        'orderData': {
          'today': {
            'orderCount': 0,
            'orderAmount': 0,
            'income': 0
          },
          'last': {
            'orderCount': 0,
            'orderAmount': 0,
            'income': 0
          },
          'month': {
            'orderCount': 0,
            'orderAmount': 0,
            'income': 0
          },
          'lastMonth': {
            'orderCount': 0,
            'orderAmount': 0,
            'income': 0
          },
          'total': {
            'orderCount': 0,
            'orderAmount': 0,
            'income': 0
          }
        }
      }
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    loadData: function () {
      var _loadData2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var res, _res$data, memberData, orderData, total, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _dataMarket.loadData)({});
            case 1:
              res = _context.v;
              if (res.code === 0 && res.data) {
                _res$data = res.data, memberData = _res$data.memberData, orderData = _res$data.orderData, total = _res$data.total;
                if (memberData) {
                  Object.keys(memberData).forEach(function (key) {
                    if (memberData[key] && (0, _typeof2.default)(memberData[key]) === 'object') {
                      _this.dataList.memberData[key] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.dataList.memberData[key]), memberData[key]);
                    }
                  });
                }
                if (orderData) {
                  Object.keys(orderData).forEach(function (key) {
                    if (orderData[key] && (0, _typeof2.default)(orderData[key]) === 'object') {
                      _this.dataList.orderData[key] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.dataList.orderData[key]), orderData[key]);
                    }
                  });
                }
                if (total) {
                  this.dataList.total = total;
                }
                console.log(this.dataList, '=================');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadData() {
        return _loadData2.apply(this, arguments);
      }
      return loadData;
    }()
  }
};